const RULES = {
  event: 'favoriteClicked',
  required: ['status', 'listingId']
};
const EVENTS = {
  manageListing: {
    action: 'MANAGE LISTING'
  },
  deleteListing: {
    action: 'DELETE LISTING'
  }
};
const create = (event, data = {}) => {
  const {
    action,
    businessTypeContext = 'SALE',
    collectionListingsAddedIds = [],
    collectionListingsRemovedIds = [],
    listingId,
    screen = '',
    source = {},
    status = false,
    subject = ''
  } = data;
  if (!EVENTS[event]) {
    const allowedEvents = Object.keys(EVENTS).join(', ');
    throw new TypeError(`Only these events are compatible with this schema: ${allowedEvents}`);
  }
  return {
    favorite: {
      action,
      businessTypeContext,
      collectionListingsAddedIds,
      collectionListingsRemovedIds,
      listingId: (listingId || '').toString(),
      screen,
      source,
      subject,
      status,
      ...EVENTS[event]
    },
    ...data,
    event: 'favoriteClicked'
  };
};
var favoriteClicked = {
  create,
  RULES
};

export { favoriteClicked as default };
